package de.connect2x.timmy.customcomponents

import de.connect2x.messenger.compose.view.i18n.I18nView
import de.connect2x.messenger.compose.view.room.settings.ExportRoomView
import de.connect2x.messenger.compose.view.room.timeline.RoomHeaderView
import de.connect2x.messenger.compose.view.room.timeline.element.message.ImageRoomMessageTimelineElementView
import de.connect2x.messenger.compose.view.settings.AppearanceSettingsColorView
import de.connect2x.messenger.compose.view.settings.AccountsOverviewView
import de.connect2x.messenger.compose.view.timelineElementView
import de.connect2x.timmy.Constants
import de.connect2x.timmy.customcomponents.roomHeaderWithArchiveButton.RoomHeaderViewWithArchiveButtonWcImpl
import de.connect2x.timmy.i18n.I18nViewWcImpl
import de.connect2x.trixnity.messenger.MatrixMessengerSettings
import de.connect2x.trixnity.messenger.settings.SettingsView
import de.connect2x.trixnity.messenger.settings.settingsView
import de.connect2x.trixnity.messenger.viewmodel.room.timeline.RoomHeaderViewModelFactory
import kotlinx.serialization.Serializable
import org.koin.dsl.module
import de.connect2x.tim.compose.i18n.I18nTIMView
import de.connect2x.timmy.GlobalCustomConfig
import de.connect2x.timmy.i18n.I18nTimViewWcImpl
import org.koin.dsl.bind


fun customComponentsModule() = module {
    single { I18nViewWcImpl(get(), get(), get(), get()) } bind I18nView::class
    single<I18nTIMView> { I18nTimViewWcImpl(get(), get(), get(), get()) }
    single<RoomHeaderViewModelFactory> {
        RoomHeaderViewModelFactoryWcImpl
    }
    single<RoomHeaderView> { RoomHeaderViewWithArchiveButtonWcImpl() }
    single<AppearanceSettingsColorView> { DisabledAccentColorViewWcImpl() }
    single<AccountsOverviewView>{ AccountsOverviewViewWcImpl() }
    single<ExportRoomView> { ExportRoomViewWcImpl() }
    if (GlobalCustomConfig.filePreviewDisabled) {
        timelineElementView<ImageRoomMessageTimelineElementView> { ImageRoomMessageTimelineElementViewWcImpl() }
    }
}

@Serializable
data class MatrixMessengerCustomSettings(
    val archiveButtonHintDisabled: Boolean? = Constants.ARCHIVE_BUTTON_HINT_DISABLED_DEFAULT,
    val filePreviewDisabled: Boolean? = true
) : SettingsView<MatrixMessengerSettings>

val MatrixMessengerSettings.customSettings by settingsView<MatrixMessengerSettings, MatrixMessengerCustomSettings>()
